export default "<div class=\"highcharts-light assurance-trend-chart-container\" data-bind=\"chartType: 'Line', dataAndOptions: dataAndOptions\"></div>\n";